/**
 * AppScreen — 앱 화면을 웹에 세우는 껍데기.
 * @description 앱 디자인 시스템을 쓰는 화면(로그인·가입·콜랩 상세)이 공유한다.
 *
 *   모바일 퍼스트로 짜고 넓은 화면에서는 **좌우 폭만** 잠근다 — 앱 시안이 폰 한 벌뿐이라
 *   넓은 폭에 맞는 배치가 정의된 적이 없다. 위아래는 자르지 않고 화면 높이를 그대로 쓴다.
 *
 *   남는 좌우는 랜딩 브랜드 블루로 두고 패널만 앱 배경색으로 세운다 — 가운데 놓인 기기를
 *   만지는 감각을 준다. **폰 폭에서는 그 파랑을 쓰지 않는다.** 좌우 여백이 없어 보일 일이
 *   없는데도 오버스크롤로 튕길 때 파란 띠가 비쳐서, 화면이 두 겹으로 읽혔다. 브랜드 색은
 *   상단 바가 이미 지고 있다.
 *
 *   한 곳에 둔 이유는 화면마다 이 조합을 따로 적으면 서로 어긋나기 때문이다.
 */
import type { ReactNode } from "react";

/** 폰 폭 상한 — 이보다 넓어져도 배치가 좋아지지 않는다. */
const PANEL_MAX_WIDTH = "480px";

export function AppScreen({ children }: { children: ReactNode }) {
  return (
    /*
     * `fw-app-screen` 은 전역 스타일이 붙잡는 표식이다 — 오버스크롤로 튕길 때 드러나는
     * `body` 캔버스는 자식이 칠할 수 없어서, `globals.css` 가 이 클래스를 보고 칠한다.
     */
    <div className="fw-app-screen flex min-h-dvh justify-center bg-[var(--fw-color-surface-neutral-primary)] min-[480px]:bg-primary">
      <div
        className="flex min-h-dvh w-full flex-col bg-[var(--fw-color-surface-neutral-primary)] font-app text-[var(--fw-color-content-neutral-primary)]"
        style={{ maxWidth: PANEL_MAX_WIDTH }}
      >
        {children}
      </div>
    </div>
  );
}
